import { formatDateMoment, setNumberWithPoint } from 'utils/utils'

export const TABLE_USER_MEMBERSHIP_DETAIL = {
    name: 'Membership Detail',
    column: [
        {
            name: 'Nama Activity',
            key: 'name',
            className: 'capitalize',
            render: ({ value }) => <div>{value?.replace('-', ' ')}</div>,
        },
        {
            name: 'Deskripsi',
            key: 'description',
        },
        {
            name: 'Total Point',
            key: 'amount',
            render: ({ value }) => <div>{value ? `${setNumberWithPoint(value)} Point` : '-'}</div>,
        },
        {
            name: 'Expired',
            key: 'expired_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY')}</div>,
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
